import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 16, height = 16, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} class={customClass} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='16' height='16' fill={color} />
    <g clip-path='url(#clip0)'>
      <rect x='-165' y='-140' width='400' height='987' fill='white' />
      <rect x='-165.5' y='-76.5' width='403' height='387' fill='white' />
      <path d='M-141 -8C-141 -10.2091 -139.209 -12 -137 -12H24C26.2091 -12 28 -10.2091 28 -8V104C28 106.209 26.2091 108 24 108H-137C-139.209 108 -141 106.209 -141 104V-8Z' fill='#F0F2F8' />
      <mask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='-123' y='11' width='132' height='73'>
        <rect x='-123' y='11' width='132' height='73' rx='4' fill='white' />
      </mask>
      <g mask='url(#mask0)'>
        <rect x='-123' y='11' width='132' height='73' fill='white' />
      </g>
      <rect x='-122.5' y='11.5' width='131' height='72' rx='3.5' stroke='#D5D6DA' />
      <path d='M-137 -11H24V-13H-137V-11ZM27 -8V104H29V-8H27ZM24 107H-137V109H24V107ZM-140 104V-8H-142V104H-140ZM-137 107C-138.657 107 -140 105.657 -140 104H-142C-142 106.761 -139.761 109 -137 109V107ZM27 104C27 105.657 25.6569 107 24 107V109C26.7614 109 29 106.761 29 104H27ZM24 -11C25.6569 -11 27 -9.65685 27 -8H29C29 -10.7614 26.7614 -13 24 -13V-11ZM-137 -13C-139.761 -13 -142 -10.7614 -142 -8H-140C-140 -9.65685 -138.657 -11 -137 -11V-13Z' fill='#D5D6DA' />
      <rect width='16' height='16' rx='2' fill='#0069FF' />
      <path d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z' fill='white' />
      <rect x='-140' y='-11' width='167' height='118' rx='3' stroke='#0069FF' stroke-width='2' />
      <rect x='-165.5' y='-76.5' width='403' height='387' stroke='#D5D6DA' />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect x='-165' y='-140' width='400' height='987' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
